import script from "./BoxCompetencias.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxCompetencias.vue?vue&type=script&setup=true&lang=js"

import "./BoxCompetencias.vue?vue&type=style&index=0&id=0069e7fc&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0069e7fc"]])

export default __exports__